import { selectBasketRentingSummary } from 'containers/OrderDetails/basketSlice'
import Schedule from 'containers/OrderDetails/Summary/Schedule'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'

const SimplifiedSummary = () => {
  const checkout = useReduxSelector(selectBasketRentingSummary)
  const { t } = useTranslation('basket')

  return (
    <>
      <div className='title'>
        <div>
          <span>{t('summary')}</span>
        </div>
      </div>

      <div className='orderInfo__summary'>
        <div className='orderInfo__summary__sum'>
          <span>{t('totalPayable')}:</span>
          <span>{checkout?.to_pay?.now?.grossPrice ? displayPrice(checkout.to_pay.now.grossPrice) : `${t('loading')}...`}</span>
        </div>
      </div>

      {checkout?.to_pay?.monthly && checkout.to_pay.monthly.length > 0 && <div className='orderInfo__summary'>
        <div className='orderInfo__summary__header'>{t('paymentSchedule')}</div>
        <Schedule schedule={checkout.to_pay.monthly} />
      </div>}
    </>
  )
}

export default SimplifiedSummary